import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '@shared/models/menu-item.model';
import { FooterAbstracClassComponent } from '../../shared/footer-abstrac-class.component';
import { menuFooter } from '@shared/configs/menu-footer';
import { RowHeaderComponent } from '../../shared/row-header/row-header.component';
import { FooterMenuItemComponent } from '../../shared/footer-menu-item/footer-menu-item.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-footer-menu',
    templateUrl: './footer-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RowHeaderComponent, FooterMenuItemComponent, TranslatePipe],
})
export class FooterMenuComponent extends FooterAbstracClassComponent {
    footerMenu: MenuItem[] = menuFooter;
}
